import * as React from "react";
import { Announcement } from "../../../entities/Announcement";
import Alert from "react-bootstrap/Alert";
import MarkdownRenderer from "../../MarkdownRenderer";

type Props = {
	announcement: Announcement;
};

const AnnouncementPanel = (props: Props) => {
	const { announcement } = props;

	return (
		<Alert variant="info" className="announcement-panel">
			<MarkdownRenderer source={announcement.text} />
		</Alert>
	)
}

export default AnnouncementPanel;
